var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Layer 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2,
    stroke: "#1B3955",
    d: "M1 1l4.083 4 4.084-4M9.167 9.018l-4.084-4-4.083 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCrossIcon);
export default __webpack_public_path__ + "static/media/select-cross-icon.a270c1ffb55e5549455ae10569a167db.svg";
export { ForwardRef as ReactComponent };